import { ColDef, ColDefField } from 'ag-grid-community';
import { IGridColumn } from './types';

export function mapToAgGridColumns<TData>(columns: IGridColumn[]): ColDef<TData>[] {
	return columns.map((col) => {
		const hasCellRenderer = !!col.cellRenderer;
		const hasField = !!col.field;

		const agColDef: ColDef<TData> = {
			...(col.field && { field: col.field as ColDefField<TData, any> }),
			headerName: col.headerName,
			sortable: col.sortable,
			filter: col.filterable,
			resizable: col.resizable,
			width: col.width,
			cellRenderer: col.cellRenderer,
			cellClass: col.cellClass,
			headerComponent: col.headerComponent,
			headerComponentParams: col.headerComponentParams,
			hide: col.hide,
			suppressHeaderMenuButton: col.suppressHeaderMenuButton ? col.suppressHeaderMenuButton : true,
			autoHeight: col.autoHeight,
			wrapText: col.wrapText,
			...(hasCellRenderer && hasField && {
				comparator: (valueA: any, valueB: any) => {
					if (valueA == null) return -1;
					if (valueB == null) return 1;
					return valueA.toString().localeCompare(valueB.toString());
				},
			}),
			colId: col.colId,
			editable: col.editable,
			cellEditor: col.cellEditor,
			cellEditorParams: col.cellEditorParams
		};

		return agColDef;
	});
}
